<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <i class="fas fa-coins mr-3 text-md"/>
                    Criptoativos
                </h2>
                <action-buttons/>
            </div>
        </template>
        <div class="py-12">
            <div
                v-show="filterModal"
                class="overflow-y-hidden min-h-full overflow-x-hidden fixed top-0 right-0 z-50 w-full  h-screen  flex justify-end  "
            >
                <div class="bg-black opacity-50 w-full h-full"></div>
                <div class=" bg-white  shadow dark:bg-gray-700 p-6 z-60">
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        <i
                            class="fas fa-arrow-left mr-3 text-md cursor-pointer"
                            @click="filterModal = false"
                        />
                        Filtros
                    </h2>
                    <div class="w-80">

                        <dropdown-select
                            v-model="form.status"
                            @input="e => (form.status = e)"
                            :options="defaultOptionsStatus"
                            placeholder="Selecione uma das opções"
                            class="p-4 "
                            label="Status"
                        />

                        <date-picker
                            v-model="form.date_from"
                            @input="e => (form.date_from = e)"
                            placeholder="Selecione a data"
                            class="p-4 "
                            label="Data de realização"
                        />

                        <dropdown-select
                            v-model="form.purchasedCoin"
                            @input="e => (form.purchasedCoin = e)"
                            :options="cryptos"
                            placeholder="Selecione uma das opções"
                            class="p-4 "
                            label="Moeda comprada"
                        />
                    </div>
                    <div class="flex flex-row justify-between p-5 pt-80">
                        <button
                            class="
                                        flex items-center px-4 py-3  border-gray-400 border-2
                                        rounded-md font-semibold text-xs text-gray-500 tracking-widest justify-center bg-white w-28
                                        focus:outline-none focus:border-white
                                        focus:shadow-outline-blue transition ease-in-out duration-150 col-span-1
                                    "
                            @click="reset"
                        >
                            Limpar
                        </button>
                        <button
                            class="
                                        flex items-center px-4 py-3  border-blue-400 border-2 w-28
                                        rounded-md font-semibold text-xs text-white tracking-widest justify-center bg-blue-400
                                        hover:text-blue-400 hover:bg-white active:bg-white focus:outline-none focus:border-white
                                        focus:shadow-outline-blue transition ease-in-out duration-150 col-span-1
                                    "
                            @click="filterModal = false"
                        >
                            Filtrar
                        </button>
                    </div>
                </div>
            </div>

            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <crypto-balance/>

                <div class="bg-white shadow-md sm:rounded-lg p-6 mt-6">
                    <flash :timeout="5000"/>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight -mb-9 mt-5">Lista de ordens</h2>

                    <inertia-table
                        :data="orders"
                        :params="params"
                        :filters="filters"
                        :enable-search="false"
                        :enable-pages="true"
                        :enable-export="false"
                        :enable-display="true"
                        :columns="columns"
                        :hasLine="false"
                        :has-icon="false"
                        :icon="false"
                        tableClasses="border-t-2 mt-8"
                        id="tradelist"
                        routeName="trade.index"
                        parent="trade"
                        @item-selected="() => null"
                    >
                        <template slot-scope="{ item: { settlement, coin, quote, created_in ='' } }" slot="coin">
                            <div>
                                <div class="font-semibold text-xs text-gray-500">
                                    {{ quote.is_buy ? 'Compra' : 'Venda' }}
                                    de
                                    {{ returnNameOfCoin(coin) }}
                                </div>
                                <div class="mt-2 flex mb-1">
                                    <div class="flex items-center mr-3">
                                        <icons
                                            :icon="returnParamsIcon(quote.is_buy ? settlement : coin, 'icon')"
                                            :color="returnParamsIcon(quote.is_buy ? settlement : coin, 'color')"
                                            :size="quote.is_buy ? '6' : '2'"
                                            otherClass="mr-2"
                                        />
                                        {{ quote.is_buy ? settlement : coin }}
                                    </div>
                                    <div class="flex items-center mr-3">
                                        <i class="fas fa-angle-right text-gray-500 fa-1xl"/>
                                    </div>
                                    <div class="flex items-center">
                                        <icons
                                            :icon="returnParamsIcon(!quote.is_buy ? settlement : coin, 'icon')"
                                            :color="returnParamsIcon(!quote.is_buy ? settlement : coin, 'color')"
                                            :size="!quote.is_buy ? '6' : '2'"
                                            otherClass="mr-2"
                                        />
                                        {{ !quote.is_buy ? settlement : coin }}
                                    </div>
                                </div>
                                <span
                                    v-if="created_in === 'backoffice'"
                                    class="text-xs rounded-full px-1.5 bg-blue-700 w-max text-white py-0.5"
                                >
                                    Operador externo
                                </span>
                            </div>
                        </template>
                        <template slot-scope="row" slot="trade.request_date">
                            <div class="text-gray-500">
                                {{ `${moment(row.item.trade.request_date).format('DD/MM/YYYY HH:mm')}` }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="status">
                            <div class="text-gray-500">
                                {{ returnStatusTranslation(row.item.trade.status) }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="quote.amount">
                            <div class="text-gray-500">
                                {{ `${numberFormat(row.item.quote.amount, row.item.coin)} ${row.item.coin}` }}
                            </div>
                        </template>
                        <template slot-scope="row" slot="quote.total">
                            <div class="font-bold text-lg">
                                {{
                                    `${numberFormat(row.item.quote.total, row.item.settlement)} ${row.item.settlement}`
                                }}
                            </div>
                        </template>
                        <template slot="action" slot-scope="row">
                            <div class="text-green-500">
                                <div
                                    class="rounded-full bg-white shadow-lg text-gray-900 h-10 w-10 flex justify-center items-center text-center"
                                    @click="() => {
                                        showCryptoReceipt = true;
                                        currentReceipt = row.item;
                                    }"
                                    role="button"
                                >
                                    <i class="fas fa-receipt"/>
                                </div>
                            </div>
                        </template>
                    </inertia-table>

                </div>
            </div>
        </div>
        <Jet-dialog-modal v-if="showCryptoReceipt" :show="showCryptoReceipt" maxWidth="md" position="fixed" id="transfer-receipt">
            <template #title>
                Comprovante de {{ currentReceipt.quote.is_buy ? 'compra' : 'venda' }}
            </template>
            <template #content>
                <div class="border-t border-gray-300 text-center">
                    <div class="flex justify-center mt-5">
                        <img :src="`data:image/png;base64, ${logoBase64}`" alt="">
                    </div>

                    <div class="pt-5 pb-5 text-lg text-black">
                        Comprovante de {{ currentReceipt.quote.is_buy ? 'compra' : 'venda' }}
                    </div>
                    <div class="pt-5 text-md text-black">
                        {{ currentReceipt.customer.name }}
                    </div>
                    <div class="pt-1 text-md text-black">
                        {{ `${currentReceipt.coin} ${numberFormat(currentReceipt.quote.amount, currentReceipt.coin)}` }}
                    </div>
                    <div class="pt-1 text-md text-black font-bold">
                        {{
                            `${currentReceipt.settlement} ${numberFormat(currentReceipt.quote.total, currentReceipt.settlement)}`
                        }}
                    </div>
                </div>
                <div class="pt-5">
                    <div class="flex justify-between mb-4 mt-5">
                        <div class="text-gray-500">
                            Banco
                        </div>
                        <div>
                            {{ currentReceipt.account.bank ? currentReceipt.account.bank.name : '--' }}
                        </div>
                    </div>
                    <div class="flex justify-between mb-4">
                        <div class="text-gray-500">
                            Agência
                        </div>
                        <div>
                            {{ currentReceipt.account.agency }}
                        </div>
                    </div>
                    <div class="flex justify-between mb-4">
                        <div class="text-gray-500">
                            Conta
                        </div>
                        <div>
                            {{ currentReceipt.account.number }}
                        </div>
                    </div>
                    <div class="flex justify-between mb-4">
                        <div class="text-gray-500">
                            Data da transação
                        </div>
                        <div>
                            {{ moment(currentReceipt.created).format('DD/MM/YYYY HH:mm') }}
                        </div>
                    </div>
                </div>
                <div class="pt-5 remove-to-print">
                    <div class="flex items-center justify-end">
                        <RoundedIcon
                            class="w-9 h-9 bg-green-500 text-white mr-4"
                            v-tippy
                            content="Baixar em PNG"
                            :icon="'far fa-file-image'"
                            @click.native="print('png')"
                        />
                        <RoundedIcon
                            class="w-9 h-9 bg-red-600 text-white"
                            v-tippy
                            content="Baixar em PDF"
                            :icon="'fas fa-file-pdf'"
                            @click.native="print('pdf')"
                        />
                    </div>
                </div>
            </template>

            <template #footer>
                <jet-secondary-button class="remove-to-print" @click.native="showCryptoReceipt = false">
                    FECHAR
                </jet-secondary-button>
            </template>
        </Jet-dialog-modal>
    </app-layout>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout";
import Welcome from "../../../Jetstream/Welcome";
import Dropdown from "../../../Jetstream/Dropdown";
import RoundedIcon from '../../Send/components/RoundedIcon';
import DropdownLink from "../../../Jetstream/DropdownLink";
import JetAutoComplete from "../../../Jetstream/AutoComplete";
import Flash from "../../../Helpers/Flash";
import InertiaTable from "../../../Helpers/Tables/InertiaTable";
import Balance from "../../../Helpers/Balance";
import numberFormat from "../utils/numberFormat";
import CardCurrency from "../components/CardCurrency";
import icons from "../utils/icons";
import Icons from "../components/Icons";
import SearchFilter from "../../../Helpers/Tables/SearchFilter";
import SearchBar from "../components/SearchBar";
import DatePicker from "../components/DatePicker";
import DropdownSelect from "../components/DropdownSelect";
import eventBus from "/resources/js/Layouts/eventBus.vue";
import JetDialogModal from '../../../Jetstream/DialogModal'
import JetSecondaryButton from '../../../Jetstream/SecondaryButton'
import CryptoBalance from '../Balance';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment'
import ActionButtons from "../ActionButtons";
import LogoBase64 from '../../../Helpers/LogoBase64.vue';

const defaultForm = {
    q: "",
    status: "",
    date_form: "",
    purchasedCoin: ""
};

const defaultOptionsStatus = [
    {id: "pending", name: "Pendente de registro"},
    {id: "error", name: "Erro de registro"},
    {id: "registered", name: "Registrado"},
    {id: "paid", name: "Pago"},
    {id: "expired", name: "Vencido"},
    {id: "canceled", name: "Cancelado"}
];

export default {
    components: {
        ActionButtons,
        Dropdown,
        Balance,
        CryptoBalance,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable,
        CardCurrency,
        Icons,
        SearchFilter,
        SearchBar,
        DatePicker,
        DropdownSelect,
        JetSecondaryButton,
        JetDialogModal,
        RoundedIcon,
        LogoBase64
    },
    props: ['orders', 'withdraw_enabled', 'logoBase64'],
    data() {
        return {
            icons,
            moment,
            numberFormat,
            form: {...defaultForm},
            showCryptoReceipt: false,
            currentReceipt: null,
            defaultOptionsStatus,
            filterModal: false,
            cryptos: [],
            columns: [
                {
                    text: "Transação",
                    className: "text-left",
                    key: "coin",
                    sortable: false
                },
                {
                    text: "Data de realização",
                    className: "text-left",
                    key: "trade.request_date",
                    sortable: true
                },
                {
                    text: "Valor final",
                    className: "text-left",
                    key: "quote.amount",
                    sortable: true
                },
                {
                    text: "Valor da transação",
                    className: "text-left",
                    key: "quote.total",
                    sortable: true
                },
                {
                    text: "",
                    className: "text-left",
                    key: "action",
                    sortable: false
                }
            ],
            filters: [
                {
                    text: 'Moeda',
                    key: 'coin',
                    type: 'dropdown',
                    options: [],
                    colSpan: 2
                },
                {
                    text: 'Data início',
                    key: 'date_from',
                    type: 'datepicker',
                    colSpan: 2
                },
                {
                    text: 'Data término',
                    key: 'date_to',
                    type: 'datepicker',
                    colSpan: 2
                }

            ],
            params: {
                sort: "trade.request_date:desc",
                page: 1,
                size: 10,
                ...this.$page.props.queryString
            }
        };
    },
    methods: {
        async getCurrencies(){
            const { data } = await axios.get('/crypto/currencies')
            this.cryptos = data.list
            this.filters[0].options = this.cryptos
                .filter(currency => currency.status === 'active')
                .map(currency => ({ ...currency, name: currency.coin, id: currency.id.toUpperCase() }))
        },
        print(type) {
            const toggleHiddenButtons = () => document
                .querySelectorAll('.remove-to-print')
                .forEach((el) => el.classList.toggle('hidden'))

            toggleHiddenButtons()
            html2canvas(document.querySelector('#transfer-receipt'), {dpi: 144, scale: 1}).then(canvas => {
                let imgData = canvas.toDataURL('image/png');
                if (type === 'png') {
                    const a = document.createElement('a');
                    a.href = imgData;
                    a.download = 'comprovante.png';
                    a.click();
                    return
                }
                let doc = new jsPDF();
                doc.addImage(imgData, 'PNG', 46, 10);
                doc.save(`comprovante.${type}`);
            });
            toggleHiddenButtons()
        },
        returnNameOfCoin(name = "BTC") {
            return this.cryptos.find(({coin}) => coin === name)?.name ?? name;
        },
        returnParamsIcon(name = "BRL", param = "icon") {
            if (name === "BRL") {
                return "BRL";
            }

            return this.icons[name][param];
        },
        returnStatusTranslation(status) {
            switch (status) {
                case 'pending':
                    return 'Ordem ainda a ser processada'
                case 'filled':
                    return 'Ordem liquidada'
                case 'partial_filled':
                    return 'Ordem parcialmente liquidada'
                case 'canceled':
                    return 'Ordem cancelada'
                case 'rejected':
                    return 'Ordem rejeitada'
                case 'expired':
                    return 'Ordem expirada'
                case 'done':
                    return 'Ordem finalizada'
                default:
                    return 'Order Recebida pelo trade'
            }
        },
        reset() {
            this.form = defaultForm;
            eventBus.$emit("clearFilter");
            this.$forceUpdate();
        },
    },
    created(){
        this.getCurrencies()
    }
};
</script>
